"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinOurRanks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="230375" id="join-our-ranks" className="relative w-full overflow-hidden dark bg-background py-20 lg:py-32">
      <div ref={ref} className={`mx-auto max-w-7xl px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-2 lg:gap-24">
          {}
          <div className="relative order-2 lg:order-1">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg shadow-2xl shadow-black/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689786/img/police_officers_precinct.png" alt="Metropolitan Central Police officers in front of precinct" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105 grayscale-[0.2]" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/60 via-transparent to-transparent" />
            </div>
            
            {}
            <div className="absolute -left-8 -top-8 -z-10 h-64 w-64 rounded-lg bg-secondary/10 blur-3xl opacity-30" />
            <div className="absolute -bottom-8 -right-8 -z-10 h-64 w-64 rounded-lg bg-primary/20 blur-3xl" />
          </div>

          {}
          <div className="order-1 flex flex-col items-center text-center lg:order-2 lg:items-start lg:text-left">
            <span className="mb-4 inline-flex items-center rounded-md bg-secondary px-4 py-1.5 text-sm font-bold tracking-wider text-secondary-foreground uppercase">
              Recruitment Division
            </span>
            
            <h2 className="font-default text-4xl font-extrabold tracking-tighter text-foreground sm:text-5xl lg:text-6xl uppercase">
              PROTECT. SERVE. LEAD.
            </h2>
            
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-muted-foreground font-default">
              The Metropolitan Central Police Department is seeking dedicated individuals to join our ranks. We offer a career defined by purpose, integrity, and a commitment to safeguarding our community through professional excellence.
            </p>

            <div className="mt-10 flex w-full flex-col gap-4 sm:flex-row sm:justify-center lg:justify-start">
              <Button size="lg" className="h-14 px-8 text-base font-bold shadow-lg bg-foreground text-background hover:bg-foreground/90 rounded-md" asChild>
                <Link to="/PublicServicesPage">
                  VIEW CAREER OPPORTUNITIES
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              
              <Button size="lg" variant="outline" className="h-14 px-8 text-base border-foreground/20 text-foreground hover:bg-foreground/5 rounded-md font-bold" asChild>
                <Link to="/TransparencyPage">
                  <Users className="mr-2 h-5 w-5" />
                  OUR MISSION
                </Link>
              </Button>
            </div>
            
            <div className="mt-12 grid grid-cols-2 gap-8 border-t border-border/30 pt-8 sm:grid-cols-3">
              <div>
                <p className="font-mono text-3xl font-bold text-secondary">500+</p>
                <p className="mt-1 text-sm font-medium text-muted-foreground uppercase tracking-wide">Active Officers</p>
              </div>
              <div>
                <p className="font-mono text-3xl font-bold text-secondary">24/7</p>
                <p className="mt-1 text-sm font-medium text-muted-foreground uppercase tracking-wide">Community Care</p>
              </div>
              <div className="col-span-2 sm:col-span-1">
                <p className="font-mono text-3xl font-bold text-secondary">#1</p>
                <p className="mt-1 text-sm font-medium text-muted-foreground uppercase tracking-wide">Safety Rating</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}